import { Clerk } from '@clerk/clerk-js';

let clerkInstance = null;

export async function initClerkAuth() {
    // Utilisez la variable d'environnement pour la clé publique
    const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

    if (!publishableKey) {
        console.error('Clé publique Clerk manquante. Vérifiez votre fichier .env');
        return null;
    }

    try {
        // Initialiser Clerk
        clerkInstance = new Clerk(publishableKey);
        await clerkInstance.load();

        // Rendre l'instance disponible globalement si nécessaire
        window.clerk = clerkInstance;

        // Stocker les informations d'authentification si l'utilisateur est déjà connecté
        if (clerkInstance.user) {
            storeAuthInfo(clerkInstance.user);
        }

        // Initialiser les éléments d'UI
        setupAuthUI();

        // Écouter les changements d'authentification
        clerkInstance.addListener(({ user }) => {
            updateAuthUI(user);
            storeAuthInfo(user); // Ajouter cette ligne
        });

        // Configurer les intercepteurs d'authentification
        setupAuthInterceptors();

        // Mettre à jour l'UI initiale
        updateAuthUI(clerkInstance.user);

        console.log('Clerk initialisé avec succès');
        return clerkInstance;
    } catch (error) {
        console.error('Erreur lors de l\'initialisation de Clerk:', error);
        return null;
    }
}

function setupAuthUI() {
    // Ajouter les écouteurs d'événements aux boutons
    const signInButton = document.getElementById('sign-in-button');
    if (signInButton) {
        signInButton.addEventListener('click', showSignIn);
    }
}

function updateAuthUI(user) {
    const userButtonContainer = document.getElementById('user-button-container');
    const signInButton = document.getElementById('sign-in-button');

    if (user) {
        // Utilisateur connecté
        if (userButtonContainer) {
            userButtonContainer.style.display = 'block';
            if (!userButtonContainer.hasChildNodes()) {
                clerkInstance.mountUserButton(userButtonContainer);
            }
        }
        if (signInButton) signInButton.style.display = 'none';
    } else {
        // Utilisateur déconnecté
        if (userButtonContainer) userButtonContainer.style.display = 'none';
        if (signInButton) signInButton.style.display = 'block';
    }
}

export function showSignIn() {
    if (clerkInstance) {
        clerkInstance.openSignIn();
    } else {
        console.error('Clerk n\'est pas initialisé');
    }
}

export function getAuthToken() {
    if (clerkInstance && clerkInstance.session) {
        return clerkInstance.session.getToken();
    }
    return null;
}

export function getUserInfo() {
    if (clerkInstance && clerkInstance.user) {
        return {
            id: clerkInstance.user.id,
            email: clerkInstance.user.primaryEmailAddress?.emailAddress,
            firstName: clerkInstance.user.firstName,
            lastName: clerkInstance.user.lastName,
            fullName: clerkInstance.user.fullName
        };
    }
    return null;
}

// Fonction pour stocker les infos dans des cookies
function storeAuthInfo(user) {
    if (user) {
        // Utiliser des cookies cross-site sécurisés
        document.cookie = `clerk_user_id=${user.id}; path=/; secure; SameSite=None`;
        document.cookie = `clerk_user_email=${user.primaryEmailAddress?.emailAddress}; path=/; secure; SameSite=None`;

        if (clerkInstance.session) {
            clerkInstance.session.getToken().then(token => {
                document.cookie = `clerk_session_token=${token}; path=/; secure; SameSite=None`;
                console.log('Token d\'authentification stocké dans les cookies');
            });
        }

        console.log('Informations d\'authentification stockées dans les cookies:', {
            id: user.id,
            email: user.primaryEmailAddress?.emailAddress
        });
    } else {
        // Supprimer les cookies
        document.cookie = 'clerk_user_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure; SameSite=None';
        document.cookie = 'clerk_user_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure; SameSite=None';
        document.cookie = 'clerk_session_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure; SameSite=None';

        console.log('Informations d\'authentification supprimées des cookies');
    }
}

// Fonction pour intercepter les clics sur les liens app (chemin vers genealogie.app)
export function setupAuthInterceptors() {
    console.log('Configuration des intercepteurs d\'authentification');

    // Intercepter les clics sur les liens vers /app
    document.addEventListener('click', (event) => {
        let target = event.target;
        while (target && target !== document) {
            if (target.tagName === 'A' && (target.getAttribute('href') === '/app' || target.getAttribute('href')?.startsWith('/app/'))) {
                event.preventDefault();

                const appUrl = target.getAttribute('href');
                console.log('Redirection vers l\'URL de l\'app via proxy:', appUrl);

                // Redirection simple, sans ajout de paramètres
                window.location.href = appUrl;
                return;
            }
            target = target.parentElement;
        }
    });
}